/* eslint-disable no-unused-vars */
import styled from 'styled-components';
import { Palette } from 'config';

export const Box = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  min-height: 100vh;
`;

export const LoaderBox = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  z-index: 99999;
`;

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 400px;
  height: auto;
  background: ${Palette.White._000};
  padding: 32px 48px;
  border-radius: 8px;
  box-shadow: 0px 1px 3px 0px rgba(30, 50, 70, 0.1), 0px 1px 2px 0px rgba(30, 50, 70, 0.06);
  margin: 40px;

  input {
    font-size: 14px;

    &:focus {
      &::placeholder {
        opacity: 0 !important;
      }
    }
  }
`;

export const Title = styled.h1`
  font-size: 24px;
  line-height: 32px;
  color: ${Palette.PrimaryGray._900};
  font-weight: 600;
  margin-bottom: 16px;
`;

export const Paragraph = styled.p`
  font-size: 12px;
  line-height: 16px;
  color: ${Palette.PrimaryGray._700};
  margin-bottom: 24px;
`;

export const PassValidationBox = styled.ul`
  padding: 0;
  list-style: none;
  margin-top: 4px;
`;

export const ValidationItem = styled.li`
  color: ${({ isRed, isGreen }) =>
    isRed
      ? `${Palette.Red._600}`
      : isGreen
      ? `${Palette.Teal._600}`
      : `${Palette.PrimaryGray._400}`};
  font-size: 12px;
  line-height: 16px;
  margin: 1px 0;
  transition: all 0.4s ease-in-out;
`;

export const InputWithCustomErrorWrap = styled.div`
  position: relative;
  margin-bottom: 48px;
`;

export const ValidationError = styled.p`
  position: absolute;
  left: 0;
  bottom: -20px;
  color: ${Palette.Red._600};
  font-size: 12px;
  line-height: 16px;
`;

export const SubmitSuccessfulBox = styled.div`
  width: 400px;
  height: auto;
  margin: auto;
  background: ${Palette.White._000};
  padding: 32px 48px;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0px 1px 3px 0px rgba(30, 50, 70, 0.1), 0px 1px 2px 0px rgba(30, 50, 70, 0.06);
`;
